module.exports = __webpack_public_path__ + "media/images/photo/Group301-d6fe46e2b86466a644f3157857361a32.png";